/* eslint-disable no-script-url */
import React from "react";
import Typography from "@material-ui/core/Typography";
import { Button } from "@material-ui/core";
import { CopyToClipboard } from "react-copy-to-clipboard";
import Popover from "@material-ui/core/Popover";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  popover: {
    pointerEvents: "none"
  },
  paper: {
    padding: theme.spacing(1)
  }
}));

export default function CopyHideText(props) {
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = React.useState(null);

  function handlePopoverOpen(event) {
    setAnchorEl(event.currentTarget);
  }

  function handlePopoverClose() {
    setAnchorEl(null);
  }

  const open = Boolean(anchorEl);

  return (
    <>
      {props.url.length > 0 ? (
        <Button style={{ marginLeft: 0, padding: 5, minHeight: 0, minWidth: 0, textTransform: "none" }}>
          <CopyToClipboard
            text={props.url}
            onCopy={() => {
              alert("Copied to clipboard: " + props.url);
            }}
          >
            <Typography onMouseEnter={handlePopoverOpen} onMouseLeave={handlePopoverClose}>
              {"************"}
            </Typography>
          </CopyToClipboard>
        </Button>
      ) : (
        "-"
      )}
      <Popover
        id="mouse-over-popover"
        className={classes.popover}
        classes={{
          paper: classes.paper
        }}
        open={open}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left"
        }}
        disableRestoreFocus
      >
        {props.url}
      </Popover>
    </>
  );
}
